module.exports = __webpack_public_path__ + "img/sec2_19.b1c6a288.png";